// extracted by mini-css-extract-plugin
export default {"Switch":"Switch_Switch__RmTxY","Handle":"Switch_Handle__g2gJ5","On":"Switch_On__QrgQD"};